import React from 'react';
import { Route, Redirect } from 'react-router';
import auth from '../../services/authService';

const ProtectedRoute = ({ component: Component, render, roles, ...rest }) => {
    const user = auth.getCurrentUser();

    return <Route {...rest}
        render = {props => !user || (roles && !roles.includes(user.role))
            ? <Redirect to={{ pathname: "/gralta/login", state: { from: props.location } }} />
            : Component ? <Component {...props} /> : render(props) } />
}
 
export default ProtectedRoute;


// WEBPACK FOOTER //
// ./src/components/common/protectedRoute.jsx